import { Outlet } from "react-router";
import Navbar from "./components/Navbar";
import FamilyWarningBanner from "./components/FamilyWarningBanner";
import { useFamilyCheck } from "./hooks/useFamilyCheck";
import { useConciergeCheck } from "./IsConcierge";
import { useEffect, useState } from "react";
import { initEntrance, registerGlobals } from "./utils/glowUp";
import { useRouteProgress } from "./hooks/useRouteProgress";

export default function Layout() {
    const hasFamily = useFamilyCheck();
    const isConcierge = useConciergeCheck();
    const [bannerDismissed, setBannerDismissed] = useState(false);

    useRouteProgress();
    useEffect(() => {
        const cleanupEntrance = initEntrance();
        registerGlobals();
        return () => cleanupEntrance?.();
    }, []);

    return (
        <div className="h-screen flex flex-col dag-app-canvas">
            {/* Fixed Navbar */}
            <Navbar />

            {/* Family Warning Banner */}
            {hasFamily === false && !bannerDismissed && isConcierge !== true && (
                <div className="w-full">
                    <FamilyWarningBanner onDismiss={() => setBannerDismissed(true)} />
                </div>
            )}

            {/* Scrollable Content Area */}
            <main className="flex-1 overflow-y-auto">
                <div className="container mx-auto px-4 py-8">
                    <Outlet />
                </div>
            </main>
        </div>
    );
}